
import * as React from "react";
import { Slot } from "@radix-ui/react-slot";
import { cn } from "@/lib/utils";
import { buttonVariants, type ButtonVariantProps } from "./button-variants";

export interface ButtonProps
  extends React.ButtonHTMLAttributes<HTMLButtonElement>,
    ButtonVariantProps {
  asChild?: boolean;
  loading?: boolean;
}

const Spinner = () => (
  <svg
    className="animate-spin mr-1 h-4 w-4 text-current"
    viewBox="0 0 16 16"
    fill="none"
  >
    <circle
      className="opacity-25"
      cx={8}
      cy={8}
      r={7}
      stroke="currentColor"
      strokeWidth={2}
    />
    <path
      className="opacity-75"
      fill="currentColor"
      d="M15 8a7 7 0 01-7 7V15A7 7 0 018 1a7 7 0 017 7z"
    />
  </svg>
);

const Button = React.forwardRef<HTMLButtonElement, ButtonProps>(
  ({ className, variant, size, asChild = false, loading = false, disabled, children, ...props }, ref) => {
    const Comp = asChild ? Slot : "button";
    const buttonProps = {
      className: cn(buttonVariants({ variant, size, className })),
      ref,
      disabled: loading || disabled,
      'aria-busy': loading,
      ...props,
    };

    if (asChild) {
      return <Comp {...buttonProps}>{children}</Comp>;
    }

    return (
      <button {...buttonProps}>
        {loading && <Spinner />}
        {children}
      </button>
    );
  }
);
Button.displayName = "Button";

export { Button, buttonVariants };
